module.exports = __webpack_public_path__ + "img/market_insight.5f6d6606.png";